import { render, staticRenderFns } from "./merchant-details.vue?vue&type=template&id=3897ca76&"
import script from "./merchant-details.vue?vue&type=script&lang=js&"
export * from "./merchant-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports